/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    BankingCompoundInterestCalc,
    BankingContributionLimitRRSPCalc,
    BankingContributionLimitTFSACalc,
    CCInterestCalculator,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [BankingCompoundInterestCalc.blockKey]: { render: BankingCompoundInterestCalc },
    [BankingContributionLimitRRSPCalc.blockKey]: { render: BankingContributionLimitRRSPCalc },
    [BankingContributionLimitTFSACalc.blockKey]: { render: BankingContributionLimitTFSACalc },
    [CCInterestCalculator.blockKey]: { render: CCInterestCalculator },
};

export default BLOCK_TO_COMPONENT_MAP;
